import React from 'react';
import { translate } from '../Services/translation';

const CheckoutOrderInfo = props => {
  return (
    <div className="columns small-12 medium-12 checkout-info__summary--full-row">
      <div className="row small-unstack no-margin checkout-cart__row summary campaign-row">
        <div className="columns small-12">
          <label className="form__label" htmlFor="address">
            {translate('checkout.campaigncode')}
          </label>
          <input
            className="form__input"
            id="campaign-code"
            onChange={event => props.onCampaignCodeChange(event.target.value)}
          />
          {props.errors && props.errors['campaignCode'] && (
            <span
              className="form__validator--error form__validator--top-narrow"
              data-error-for="campaign-code"
            >
              {props.errors['campaignCode'][0]}
            </span>
          )}
          <button
            className="button"
            onClick={() => props.onSubmitCampaignCode()}
          >
            {translate('checkout.usecampaigncode')}
          </button>
        </div>
        <div className="columns checkout-info__summary--full-row small-12">
          {props.discount && (
            <div className="order-discount">
              {translate('checkout.order.discount')}{' '}
              <span className="checkout-info__summary--expand"></span>{' '}
              <span className="text-bold discount-price"> - {props.discount} </span>{' '}
            </div>
          )}
          <div>
            {translate('checkout.order.deliverycost')}{' '}
            <span className="checkout-info__summary--expand"></span>{' '}
            <span className="text-bold">{props.deliveryCost} </span>{' '}
          </div>
          <div>
            {translate('checkout.order.total')}{' '}
            <span className="checkout-info__summary--expand"></span>{' '}
            <span className="text-bold">{props.totalPriceWithDelivery}</span>{' '}
          </div>
        </div>
      </div>
      <div className="row small-unstack no-margin checkout-cart__row summary total">
        <div className="columns checkout-info__summary--full-row">
          <div>
            {translate('checkout.order.vat')}{' '}
            <span className="checkout-info__summary--expand"></span> {props.vat}
          </div>
          <div className="text-bold">
            {translate('checkout.order.grandTotal')}{' '}
            <span className="checkout-info__summary--expand"></span>{' '}
            {props.grandTotal}{' '}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckoutOrderInfo;
